import { AvailableMedicalService } from '../../models/Entities/MedicalServices/AvailableMedicalService';
import { ErrorType } from '../../models/HttpError';
import { CommonState } from '../common/state/commonState';

/** Página del listado: lo que devolvió el servidor para la última consulta (búsqueda + paginado). */
export interface MedicalServicesPageState {
  items: AvailableMedicalService[];
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  searchText?: string;
  available?: boolean;
  /** Clave de la consulta en vuelo o ya recibida, para no repetir pedidos iguales. */
  queryKey?: string;
  isLoading: boolean;
  loaded: boolean;
  failed: boolean;
  error: ErrorType | undefined;
}

export const MedicalServicesPageUnloadState: MedicalServicesPageState = {
  items: [],
  pageNumber: 1,
  pageSize: 25,
  totalRecords: 0,
  totalPages: 0,
  isLoading: false,
  loaded: false,
  failed: false,
  error: undefined
};

export interface AvailableMedicalServiceState
  extends CommonState<AvailableMedicalService> {
  /** Listado con búsqueda y paginado en servidor (independiente de `list`, que es el catálogo completo). */
  page: MedicalServicesPageState;
  // update all
  isUpdatingAll: boolean;
  isUpdatingAllSuccess: undefined | boolean;
  FailUpdatingAll: boolean;

  // Changing status
  isChangingStatus: boolean;
  successChangingStatus: boolean | undefined;
  failOnChangingStatus: boolean;

  // Specialties
  isLoadingSpecialties: boolean;
  failOnLoadingSpecialties: boolean;
  isAddingSpecialty: boolean;
  failOnAddingSpecialty: boolean;
  isRemovingSpecialty: boolean;
  failOnRemovingSpecialty: boolean;
  errorSpecialties: ErrorType | undefined;
}

export const AvailableMedicalServicesUnloadState: any = {
  // loading all
  isLoadingAll: false,
  isLoadingAllSuccess: undefined,
  FailGettingAll: false,

  // update all
  isUpdatingAll: false,
  isUpdatingAllSuccess: undefined,
  FailUpdatingAll: false,

  // loading one
  isLoadingOne: false,
  isLoadingOneSuccess: undefined,
  FailGettingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  FailSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  FailAdding: false,

  isFiltered: false,
  filterCriteria: undefined,

  // changing status
  isChangingStatus: false,
  isChangingStatusSuccess: undefined,
  FailChangingStatus: false,

  // specialties
  isLoadingSpecialties: false,
  failOnLoadingSpecialties: false,
  isAddingSpecialty: false,
  failOnAddingSpecialty: false,
  isRemovingSpecialty: false,
  failOnRemovingSpecialty: false,
  errorSpecialties: undefined,

  list: [],
  page: MedicalServicesPageUnloadState,
  Selected: undefined,
  Error: undefined
};
